import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockOrderInfo = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderInfoRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderInfoResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoRequest.xml'} title={t('Пример запроса') + ' ' + t('Размещение')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Размещение')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoRequest.xml'} title={t('Пример запроса') + ' ' + t('Агентские договора с доп.выгодой')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoGainResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Агентские договора с доп.выгодой')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoRequest2.xml'} title={t('Пример запроса') + ' ' + t('Оплата в отеле')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoResponse2.xml'} title={t('Пример успешного ответа') + ' ' + t('Оплата в отеле')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderInfoResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockOrderInfo;